export const MLFieldOptions = [

  {
    value: "origin_pcode.lsoa",
    type: "string",
  },
  {
    value: "origin_pcode.msoa",
    type: "string",
  },
  {
    value: "origin_pcode.oa",
    type: "string",
  },
  {
    value: "origin_pcode.district",
    type: "string",
  },
  {
    value: "origin_pcode.district_name",
    type: "string",
  },
  {
    value: "origin_pcode.la_name",
    type: "string",
  },
  {
    value: "origin_pcode.rurality",
    type: "string",
  },
  {
    value: "origin_pcode.cars_per_household",
    type: "number",
  },
  {
    value: "origin_pcode.income",
    type: "number",
  },

  {
    value: "dest_pcode.lsoa",
    type: "string",
  },
  {
    value: "dest_pcode.msoa",
    type: "string",
  },
  {
    value: "dest_pcode.oa",
    type: "string",
  },
  {
    value: "dest_pcode.district",
    type: "string",
  },
  {
    value: "dest_pcode.district_name",
    type: "string",
  },
  {
    value: "dest_pcode.la_name",
    type: "string",
  },
  {
    value: "dest_pcode.rurality",
    type: "string",
  },
  {
    value: "dest_pcode.cars_per_household",
    type: "number",
  },
  {
    value: "dest_pcode.income",
    type: "number",
  },

  {
    value: "public_school_data.propensity_walk",
    type: "number",
  },
  {
    value: "public_school_data.propensity_cycle",
    type: "number",
  },
  {
    value: "public_school_data.propensity_car",
    type: "number",
  },
  {
    value: "public_school_data.propensity_bus",
    type: "number",
  },
  {
    value: "public_school_data.propensity_train",
    type: "number",
  },
  {
    value: "public_school_data.propensity_other",
    type: "number",
  },
  {
    value: "public_school_data.name",
    type: "string",
  },
  {
    value: "public_school_data.total_students",
    type: "number",
  },

  // {
  //   value: "public_school_data.propensity_walk",
  //   type: "number",
  // },
  // {
  //   value: "public_school_data.propensity_cycle",
  //   type: "number",
  // },
  // {
  //   value: "public_school_data.propensity_car",
  //   type: "number",
  // },
  // {
  //   value: "public_school_data.propensity_bus",
  //   type: "number",
  // },
  // {
  //   value: "public_school_data.propensity_train",
  //   type: "number",
  // },
  // {
  //   value: "public_school_data.propensity_other",
  //   type: "number",
  // },
  // {
  //   value: "public_school_data.name",
  //   type: "string",
  // },
  // {
  //   value: "public_school_data.total_students",
  //   type: "number",
  // },


  // {
  //   value: "terms_archive_journeys.user_type",
  //   type: "choices",
  //   choices: [
  //     { name: "PARENT", value: "PARENT" },
  //     { name: "STAFF", value: "STAFF" },
  //     { name: "GUEST", value: "GUEST" },
  //   ],
  // },
  // {
  //   value: "terms_archive_journeys.journey_type",
  //   type: "choices",
  //   choices: [
  //     { name: "STUDENT", value: "STUDENT" },
  //     { name: "STAFF", value: "STAFF" },
  //     { name: "OTHER", value: "OTHER" },
  //   ],
  // },
  {
    value: "terms_archive_journeys.student_id",
    type: "number",
  },
  {
    value: "terms_archive_journeys.user_id",
    type: "number",
  },
  {
    value: "terms_archive_journeys.user_choice",
    type: "choices",
    choices: [
      { name: "Car", value: "CAR" },
      { name: "Carpool", value: "CARPOOL" },
      { name: "Taxi", value: "TAXI" },
      { name: "Walking", value: "WALKING" },
      { name: "Public Bus", value: "PUBLIC_BUS" },
      { name: "School Bus", value: "SCHOOL_BUS" },
      { name: "Train", value: "TRAIN" },
      { name: "Bicycling", value: "BICYCLING" },
    ],
  },
  {
    value: "terms_archive_journeys.user_journey_preference",
    type: "number",
  },
  // {
  //   value: "terms_archive_journeys.term",
  //   type: "choices",
  //   choices: [
  //     { name: "Current", value: "current" },
  //     { name: "Autumn", value: "autumn" },
  //     { name: "Spring", value: "spring" },
  //   ],
  // },
  {
    value: "terms_archive_journeys.primary_transport_type",
    type: "choices",
    choices: [
      { name: "Car", value: "CAR" },
      { name: "Carpool", value: "CARPOOL" },
      { name: "Taxi", value: "TAXI" },
      { name: "Walking", value: "WALKING" },
      { name: "Public Bus", value: "PUBLIC_BUS" },
      { name: "School Bus", value: "SCHOOL_BUS" },
      { name: "Train", value: "TRAIN" },
      { name: "Bicycling", value: "BICYCLING" },
    ],
  },
  {
    value: "terms_archive_journeys.is_staff",
    type: "choices",
    choices: [
      { name: "Yes", value: 1 },
      { name: "No", value: 0 },
    ],
  },

  {
    value: "step_journeys.id",
    type: "number",
  },
  {
    value: "step_journeys.status",
    type: "choices",
    choices: [
      { name: "OK", value: "OK" },
      { name: "ERROR", value: "ERROR" },
    ],
  },
  {
    value: "step_journeys.school_urn",
    type: "number",
  },
  {
    value: "step_journeys.destination_latlng",
    type: "string",
  },
  {
    value: "step_journeys.step_journeys_upload_id",
    type: "number",
  },
  {
    value: "step_journeys.terms_archive_journeys_id",
    type: "number",
  },
  {
    value: "step_journeys.user_type",
    type: "choices",
    choices: [
      { name: "PARENT", value: "PARENT" },
      { name: "STAFF", value: "STAFF" },
      { name: "GUEST", value: "GUEST" },
    ],
  },
  {
    value: "step_journeys.journey_type",
    type: "string",
  },
  {
    value: "step_journeys.student_year",
    type: "number",
  },
  {
    value: "step_journeys.student_year_level",
    type: "choices",
    choices: [
      { name: "PRIMARY", value: "PRIMARY" },
      { name: "SECONDARY", value: "SECONDARY" },
      { name: "ALL_THROUGH", value: "ALL_THROUGH" },
    ],
  },
  {
    value: "step_journeys.origin_postcode",
    type: "string",
  },
  {
    value: "step_journeys.origin_latlng",
    type: "string",
  },
  {
    value: "step_journeys.journey_distance",
    type: "number",
  },
  {
    value: "step_journeys.journey_time",
    type: "number",
  },
  {
    value: "step_journeys.direct_distance",
    type: "number",
  },
  {
    value: "step_journeys.distance_group",
    type: "string",
  },

  {
    value: "step_journeys.uphill_eff",
    type: "number",
  },
  {
    value: "step_journeys.downhill_eff",
    type: "number",
  },
  {
    value: "step_journeys.avg_incline_perc",
    type: "number",
  },
  {
    value: "step_journeys.walk_time",
    type: "number",
  },
  {
    value: "step_journeys.walk_distance",
    type: "number",
  },
  {
    value: "step_journeys.bicycle_time",
    type: "number",
  },
  {
    value: "step_journeys.bicycle_distance",
    type: "number",
  },
  {
    value: "step_journeys.car_time",
    type: "number",
  },
  {
    value: "step_journeys.car_distance",
    type: "number",
  },
  {
    value: "step_journeys.pt_total_time",
    type: "number",
  },
  {
    value: "step_journeys.pt_total_distance",
    type: "number",
  },

  {
    value: "step_journeys.pt_primary_mode",
    type: "number",
  },
  {
    value: "step_journeys.pt_time",
    type: "number",
  },
  {
    value: "step_journeys.pt_distance",
    type: "number",
  },
  {
    value: "step_journeys.pt_walk_time",
    type: "number",
  },
  {
    value: "step_journeys.pt_walk_distance",
    type: "number",
  },
  {
    value: "step_journeys.walk_to_first_station_distance",
    type: "number",
  },
  {
    value: "step_journeys.walk_to_first_station_time",
    type: "number",
  },
  {
    value: "step_journeys.walk_from_station_distance",
    type: "number",
  },
  {
    value: "step_journeys.walk_from_station_time",
    type: "number",
  },
];
